import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogoutApi } from '../api/auth.api';
import { apiHandler } from '../utils/apiHandler';

export default function TopNav({ onToggleSidebar }) {
  const [profileOpen, setProfileOpen] = useState(false);
  const dropRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClick(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  async function handleLogout() {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (!confirmLogout) return;

    try {
      await apiHandler(() => adminLogoutApi());
    } catch (err) {
      console.log("Logout failed", err);
    } finally {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminData");
      navigate("/login");
    }
  }

  const adminData = JSON.parse(
    localStorage.getItem("adminData")
  );

  return (
    <header id="topnav">
      <button
        onClick={onToggleSidebar}
        className="lg:hidden flex items-center justify-center w-9 h-9 rounded-lg hover:bg-slate-100 transition-colors"
        style={{ border: 'none', background: 'transparent', cursor: 'pointer', flexShrink: 0 }}
      >
        <i className="fas fa-bars text-slate-500 text-base" />
      </button>

      <div className="search-wrap">
        <i className="fas fa-magnifying-glass" />
        <input type="text" className="search-input" placeholder="Search users, orgs, or campaigns…" />
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: 5, background: '#f0fdf0', border: '1px solid #b7e5bb', padding: '5px 10px', borderRadius: 99 }}>
          <div className="pulse-dot" style={{ width: 7, height: 7, borderRadius: '50%', background: '#2E7D32' }} />
          <span style={{ fontSize: 11, fontWeight: 600, color: '#2E7D32' }}>Live</span>
        </div> */}

        <button style={{ position: 'relative', width: 38, height: 38, borderRadius: 10, background: '#F8FAFC', border: '1.5px solid #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <i className="fas fa-bell" style={{ fontSize: 14, color: '#64748B' }} />
          <span style={{ position: 'absolute', top: 6, right: 6, width: 8, height: 8, background: '#ec7426', borderRadius: '50%', border: '2px solid #fff' }} />
        </button>

        <div className={`profile-dropdown-wrap${profileOpen ? ' open' : ''}`} ref={dropRef}>
          <div className="profile-btn" onClick={() => setProfileOpen(p => !p)}>
            <div className="profile-avatar">
              {adminData?.firstName?.charAt(0)}
              {adminData?.lastName?.charAt(0)}
            </div>
            <div className="hidden sm:block">
              <div className="profile-name">{adminData?.firstName} {adminData?.lastName}</div>
              <div className="profile-role">{adminData?.role}</div>
            </div>
            <i className="fas fa-chevron-down profile-chevron" />
          </div>
          <div className="profile-menu">
            <div className="profile-menu-header">
              <div className="profile-menu-name">{adminData?.firstName} {adminData?.lastName}</div>
              <div className="profile-menu-email">{adminData?.email}</div>
            </div>
            <a href="/settings" className="profile-menu-item" onClick={() => setProfileOpen(false)}>
              <i className="fas fa-gear" />Settings
            </a>
            <div className="profile-menu-divider" />
            <button className="profile-menu-item danger" onClick={handleLogout} style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}>
              <i className="fas fa-right-from-bracket" />Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
